import { t, i18next } from './i18next';

export const defaultLanguage = 'en';
import merge from 'lodash-es/merge';

const otherLanguages = {
  da: 'da',
  fi: 'fi',
  is: 'is',
  nb: 'nb',
  sv: 'sv'
};

export const supportedLanguages = {
  ...otherLanguages,
  en: 'en'
};

const supportedLanguagesLegacy = {
  ...supportedLanguages,
  nb: 'no'
};


export const timeAgoLanguages = supportedLanguagesLegacy;

export const antLocalParts = {
  da: 'da_DK',
  fi: 'fi_FI',
  en: 'en_GB',
  is: 'is_IS',
  nb: 'nb_NO',
  sv: 'sv_SE'
};

export const locales = {  // temporary fallback solution
  ...antLocalParts,
  en: 'en_US'
};

export const antLocaleLibrary = async (locale) => {
  const localeCode = antLocalParts[locale];
  const defaultLocales = (await import(`../../node_modules/antd/es/locale/${antLocalParts[defaultLanguage]}.js`)).default;
  const locales = merge({}, defaultLocales, (await import(`../../node_modules/antd/es/locale/${localeCode}.js`)).default);
  locales.Popconfirm = {
    okText: t('global.boolean.yes'),
    cancelText: t('global.boolean.no')
  };
  locales.Form.defaultValidateMessages.required = t('global.exception.required');
  locales.Form.optional = `- ${t('global.Optional')}`;
  return locales;
};

const analyticsLanguages = {
  en: 'English',
  nb: 'Norsk',
  da: 'Dansk',
  is: 'Islenska',
  sv: 'Svenska',
  fi: 'Suomi'
};

export const analyticsLanguage = () => {

  let lang = i18next.language;
  if (lang === 'no') {
    lang = 'nb';
  }

  const al = analyticsLanguages[lang];
  return al || analyticsLanguages.en;
};
